'use strict';

angular.module('atex.dam').controller('DamPhysicalPageSearchController', ['$scope', '$interval', 'DamSearchService', 'DamFoldersService',
function($scope, $interval, DamSearchService, DamFoldersService) {
  $scope.query = DamSearchService.getCurrentPhysicalPagesQuery();

  function createList(key, values) {
    return {
      key: key,
      values: values,
      operator: false,
      extraValues: [],
      type: "LIST",
      useId: false,
      useValue: false,
      useBoolean: false,
      split: false,
      queryOperator: ""
    };
  }

  function createBoolean(key, values) {
    return {
      key: key,
      values: values,
      operator: false,
      extraValues: [],
      type: "BOOLEAN",
      useId: false,
      useValue: true,
      useBoolean: false,
      split: false,
      queryOperator: "",
      ignore: false
    };
  }

  function addField(query, field) {
    if (!query.fields) {
      query.fields = [];
    }
    query.fields.push(field);
  }

  function getField(query, id) {
    var fields = query.fields || [];

    return _.find(fields, function (field) {
      return field.key === id;
    });
  }

  function checkList(query, id, values) {
    var field = getField(query, id);

    if (field) {
      field.values = values;
    } else {
      addField(query, createList(id, values));
    }
  }

  function checkBoolean(query, id, values) {
    var field = getField(query, id);

    if (field) {
      field.values = values;
    } else {
      addField(query, createBoolean(id, values));
    }
  }

  $scope.full = function (query) {
    checkList(query, "atex_desk_objectType", ["page"]);
    checkList(query, "tag_dimension.partition_ss", ["production"]);
    checkBoolean(query, "physicalPage_ss", ["true"]);

    query.physicalPages = "true";
    if (query.fields) {
      query.fields.forEach(function (field) {
        if (field.type === 'DATE') {
          if (field.disablePatchDate === true){
            atex.dam.ViewUtils.patchDateIntervalFullRange(field.values);
          }else{
            atex.dam.ViewUtils.patchDateInterval(field.values);
          }
        }
      });
    }

    if (!query.viewMode) {
      query.viewMode = "physical-page";
    }

    query.singleEdition = query.singleEdition === true;
    $scope.$root.physSingleEdition = query.singleEdition;
    query.display = $scope.$root.physSingleEdition ? 4 : 3;

    var ts = Date.now();
    DamSearchService.setLastQueryStartTs(ts);
    var extraInfo = {
      queryTs: ts,
      viewMode: query.viewMode,
      type: query._type,
    };
    DamSearchService.advancedSearch(query, extraInfo);

    $interval(function () {
      $scope.$root.$broadcast("dam:setSliderEvent", {display: query.display});
    }, 500, 1);
  };
}]);